export enum TabNavigationItemName {
	Browser = 'Browser',
	Charts = 'Charts',
	Market = 'Market',
	Rewards = 'Rewards',
	Wallet = 'Wallet'
}
